// Base: @base/abstracts/components/business-matching.abstract.ts
import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import { BusinessMatchingAbstract } from '@base/abstracts/components/business-matching.abstract';

@Component({
  selector: 'app-business-matching',
  imports: [ModalHeaderComponent, TranslatePipe],
  providers: [forwardRef(() => TranslatePipe)],
  templateUrl: './business-matching.component.html',
  styleUrl: './business-matching.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessMatchingComponent extends BusinessMatchingAbstract {}
